import React from "react";

export const AuthRestartButton = (props) => {
  const buttonText = props.buttonText || "Back to Loans"
  const bgColor = props.bgColor || "darkgrey";
  const margins = props.margins ? props.margins : "mt-3";
  const extraStyles = props.extraStyles ? props.extraStyles : {};

  return (
    <button
      type="button"
      className={"button full " + margins}
      style={{ backgroundColor: bgColor, color: "white", ...extraStyles }}
      onClick={props.backToLoans}
      data-e2e-id="backToLoans"
    >
      {buttonText}
    </button>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/misc/restart-button.component.js